

export class FacultyMedicalProcedureParameterModel{
    Id:string;
    FacultyMedicalProcedureId:string;
    FellowshipSpecialisationId:string;
    ProgramcategoryId:number;
    Name:string; 
}